export default {
  mobileDesigns: state =>
    state.designs.length &&
    state.designs
      // .filter(x => x.mobile_uiux_design)
      .map(x => ({
        _id: x._id,
        image: x.mobile_uiux_design,
        name: x.name,
        page: x.page,
        type: x.type,
        description: x.description,
        ticketID: x.ticketID,
        UX_status: x.UX_status,
        UX_Mobile_status: x.UX_Mobile_status,
        tasklistID: x.taskList,
        ux_notes: x.ux_notes ? x.ux_notes : [],
        figma: x.figma
      })),

  webDesigns: state =>
    state.designs.length &&
    state.designs.map(x => ({
      _id: x._id,
      image: x.web_uiux_design,
      name: x.name,
      page: x.page,
      type: x.type,
      description: x.description,
      ticketID: x.ticketID,
      UX_status: x.UX_status,
      UX_Web_status: x.UX_Web_status,
      tasklistID: x.taskList,
      ux_notes: x.ux_notes ? x.ux_notes : [],
      ux_history: x.ux_history,
      figmaFile: x.figmaFile,
      figmaNode: x.figmaNode
    })),

  approvedStoriesWeb: state =>
    state.designs.length &&
    state.designs.filter(
      x => x.UX_Web_status === "Approved" && x.web_uiux_design
    ),

  unapprovedStoriesWeb: state =>
    state.designs.length &&
    state.designs.filter(
      x => x.UX_Web_status !== "Approved" && x.web_uiux_design
    ),

  approvedStoriesMobile: state =>
    state.designs.length &&
    state.designs.filter(
      x => x.UX_Mobile_status === "Approved" && x.mobile_uiux_design
    )
};
